import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@src/redux/store';
import { getCompaniesDetail } from './companySidebarThunk';

interface InitialState {
  id: string;
  isOpen: boolean;
  companyInfo: {
    name: string;
    createdAt: string;
    avatarUrl: string;
    note: string;
    accountantEmail: string;
    accountantMobileNumber: string;
  };
}

const initialState: InitialState = {
  id: '',
  isOpen: false,
  companyInfo: {
    name: '',
    createdAt: '',
    avatarUrl: '',
    note: '',
    accountantEmail: '',
    accountantMobileNumber: '',
  },
};

const companySidebarSlice = createSlice({
  name: 'company/companySidebar',
  initialState,
  reducers: {
    openSidebar(state, { payload }) {
      state.isOpen = !state.isOpen;
      state.id = payload;
    },
    onChangeNote(state, { payload }) {
      state.companyInfo.note = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCompaniesDetail.fulfilled, (state, { payload }) => {
      const {
        id,
        name,
        createdAt,
        avatarUrl,
        accountantEmail,
        note,
        accountantMobileNumber,
      } = payload;
      const companyInfo = {
        id,
        name,
        createdAt,
        avatarUrl,
        accountantEmail,
        note,
        accountantMobileNumber,
      };

      state.id = payload.id;
      state.companyInfo = { ...companyInfo };
    });
  },
});

export const { openSidebar, onChangeNote } = companySidebarSlice.actions;

export default companySidebarSlice.reducer;

const selfSelector = (state: RootState) => state.companySidebar;

export const companySidebarSelector = createDraftSafeSelector(
  selfSelector,
  (companySidebarState) => companySidebarState
);
